import React, {useEffect} from 'react';

import PropTypes from 'prop-types';

import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function YesNoViewTemplate({
    message,
    onConfirm,
    onCancel,
    yesLabel = 'MODAL.YES_NO_CONFIRM_LABEL',
    noLabel = 'MODAL.YES_NO_CANCEL_LABEL',
    t,
    loading,
    swapButtons,
    doNotShowCancel
}) {
    return (
        <div>
            <KeyDownListener onConfirm={onConfirm}/>
            <p className='type--base u-padd--right--med u-mar--top--med type--color--secondary'>
                {t(message)}
            </p>
            <div className='modal__footer is-right'>
                {!doNotShowCancel && swapButtons &&
                    <BaasicButton
                    className='btn btn--med btn--light'
                        onClick={onCancel}
                        disabled={loading}
                        label={t(noLabel)}
                    />
                }
                <BaasicButton
                    className='btn btn--med btn--primary'
                    onClick={onConfirm}
                    disabled={loading}
                    rotate
                    icon={
                        loading
                            ? 'u-icon u-icon--xmed u-icon--sync u-rotate--login'
                            : 'u-display--none'
                    }
                    label={t(yesLabel)}
                />
                {!doNotShowCancel && !swapButtons &&
                    <BaasicButton
                    className='btn btn--med btn--light'
                        onClick={onCancel}
                        disabled={loading}
                        label={t(noLabel)}
                    />
                }
            </div>
        </div>
    );
}

YesNoViewTemplate.propTypes = {
    message: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    yesLabel: PropTypes.string,
    noLabel: PropTypes.string,
    loading: PropTypes.bool,
    t: PropTypes.func,
    swapButtons: PropTypes.bool,
    doNotShowCancel: PropTypes.bool
};

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}
KeyDownListener.propTypes = {
};

export default defaultTemplate(YesNoViewTemplate);
